import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CoreModule } from './core/core.module';

import { PageNotFoundComponent } from './core/components/page-not-found/page-not-found.component';
import { LandingPageModule } from './landing-page/landing-page.module';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';

const appRoutes: Routes = [
  { path: 'contact', component: PageNotFoundComponent },
  { path: 'logout', component: PageNotFoundComponent },
  { path: 'landing-page', loadChildren: () => import('./landing-page/landing-page.module').then(m => m.LandingPageModule) },
  { path: '', redirectTo: '/landing-page', pathMatch: 'full' },
  { path: '**', component: PageNotFoundComponent }
];



@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes, {}),
    CoreModule,
    LandingPageModule,
    ReactiveFormsModule ,
    FormsModule
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule {
}
